export default __webpack_public_path__ + "static/media/NOVA-LOGO-SEM-FUNDO.0407460b.svg";